import Dialog from '@/components/common/Dialog';
import { ReactEventHandler, useEffect, useLayoutEffect, useRef, useState } from 'react';
import useCountdown from '@/hooks/useCountDown';
import { fixedBody, looseBody } from '@/utils/tool';

type PopupNoticeType = {
  visible?: boolean;
  onClose?: ReactEventHandler;
  data?: {
    icon_img: string;
    link: string;
    message: {
      button_text: string;
      countdown: number;
      message: string;
      short_message: string;
      url: string;
    };
  }[];
};

export default function PopupNotice(props: PopupNoticeType) {
  const [visible, setVisible] = useState(props.visible || false);
  const { data } = props;
  const timer = useRef<any>();
  const [newData, setNewData] = useState(data);

  const { timeString } = useCountdown(
    () => {
      return (data?.find(item => item?.message?.countdown)?.message?.countdown || 0) + Date.now() / 1000;
    },
    {
      start: () => Date.now() / 1000,
      onEnd: () => {
        // setTimeout(() => {
        //   location.reload();
        // }, 100);
      }
    }
  );

  useLayoutEffect(() => {
    if (props.visible) {
      fixedBody();
      timer.current = setTimeout(() => {
        document.getElementById('__next').style.filter = 'blur(2px)';
      }, 200);
    }
    if (props.visible !== visible) {
      setVisible(props.visible);
    }
    return () => {
      looseBody();
      document.getElementById('__next').style.filter = 'unset';
      if (timer.current) {
        clearTimeout(timer.current);
        timer.current = null;
      }
    };
  }, [props.visible]);

  return (
    <Dialog
      visible={visible}
      maskClosable={true}
      transparent={true}
      onClose={props.onClose}
      className="!items-baseline !pt-9 w-[88%]">
      {newData?.map((item, index) => {
        return (
          <div key={index} className="bg-surface-100-bg mb-5 px-[15px] py-2.5 rounded-400">
            <div
              className="enki-body-2xs text-[#333333] mb-2.5"
              dangerouslySetInnerHTML={{ __html: item?.message?.message.replace(/{countdown}/g, timeString) }}></div>
            {!!item.link && (
              <a
                href={item.link + `${item?.link?.indexOf('?') > 0 ? '&source=top_message' : ''}`}
                className="text-[#008ed6]">
                {item?.message?.button_text}
              </a>
            )}
          </div>
        );
      })}
    </Dialog>
  );
}
